import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ModalResultFinalTopic } from "../../../components/common/ModalResultFinalTopic";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";

const steps = {
	initialDialog: 1,
	final: 2,
};

export const Tema4SubtopicSixFinalPoint = () => {
	const navigator = useNavigate();
	const { activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points, statusTopic } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema6],);
	// console.log(tasksList, points, statusTopic)
	const { loaded } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.tema4.subtopicSix.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>

			{uiToShow === steps.initialDialog && (
				<>
					<ModalResultFinalTopic
						title={statusTopic === 2 ? "¡Bien hecho!" : "¡Oh¡ no"}
						subTitle={
							statusTopic === 2
								? "¡Felicidades! has completado el Subtema 6."
								: "No has conseguido los puntos necesarios. inténtalo de nuevo."
						}
						buttonText={statusTopic === 2 ? "Continuar" : "Siguiente"}
						statusModal={statusTopic}
						points={points}
						actionButton={() => {
							setUiToShow(steps.final);
						}}
					/>
				</>
			)}

			{uiToShow === steps.final && (
				<>
					<PanelActivities
						buttonText="¡Continuar!"
						title="Subtema 6: Lavado de dinero"
						titleActivity="Actividades realizadas:"
						points={points}
						insigniaBackground={statusTopic}
						actionButton={() => {
							navigator("/home4/tema4/final");
						}}
						activities={tasksList}
					/>
				</>
			)}
		</>
	);
};
